<template>
	<div class="relative flex w-full flex-col">
		<slot>
			<div
				class="w-full overflow-hidden rounded-lg border-2 border-dashed border-primary p-4 duration-300"
				:class="{
					'hover:bg-gray-100': !src
				}"
			>
				<div v-if="!src" class="flex flex-col items-center text-primary">
					<Icon name="mdi:attachment" class="h-6 w-6" />
					<span class="mt-1 text-sm">
						{{ $t("upload_n", { name }) }}
					</span>
				</div>
				<div v-if="src" class="grid grid-cols-2">
					<div class="flex flex-col items-center">
						<div class="flex cursor-pointer flex-col items-center text-primary" @click="downloadFile">
							<Icon name="mdi:download" class="h-6 w-6" />
							<span class="mt-1 text-sm">
								{{ $t("download_n", { name }) }}
							</span>
						</div>
					</div>
					<div class="flex flex-col items-center">
						<div class="text-red-500 flex cursor-pointer flex-col items-center" @click="removeFile">
							<Icon name="mdi:delete" class="h-6 w-6" />
							<span class="mt-1 text-sm">
								{{ $t("delete_n", { name }) }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</slot>
		<span v-if="!src && !disableUpload" class="absolute bottom-0 end-0 start-0 top-0 overflow-hidden">
			<input
				ref="setInputImage"
				type="file"
				class="absolute bottom-0 left-0 right-0 top-0 h-full w-full cursor-pointer opacity-0"
				style="transform: scale(10)"
				@change="selectVideo($event)"
			/>
		</span>
	</div>
</template>

<script setup lang="ts">
import download from "downloadjs"
import type { Video } from "~/models/video"

const videoStore = useVideoStore()
const runtimeConfig = useRuntimeConfig()
const { $toastErrors } = useNuxtApp()

const emit = defineEmits<{
	change: [Video | null]
	input: [File | null]
	uploading: [boolean]
}>()
const props = defineProps<{
	name?: string
	disableUpload?: boolean
	src?: string | null
}>()

const downloadFile = () => {
	if (props.src) download(runtimeConfig.public.baseUrl + props.src)
}

const removeFile = () => {
	emit("change", null)
	emit("input", null)
}
const onVideoUpload = async (file: File) => {
	emit("uploading", true)
	try {
		const formData = new FormData()
		formData.set("video", file)
		const video = await videoStore.uploadVideo(file)
		emit("uploading", false)
		return video
	} catch (e: any) {
		emit("uploading", false)
		$toastErrors(e)
		return null
	}
}
const selectVideo = async (event: any) => {
	if (props.disableUpload) return
	const files = [...(event.target.files || event.dataTransfer.files || [])]
	const file = files?.[0] as File | undefined
	if (!file) {
		emit("change", null)
		return
	}
	const f = await onVideoUpload(file)
	event.target.value = null
	emit("change", f)
	emit("input", file)
}
</script>
